<template>
  <div class="space-y-6">
    <div class="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-6">
      <h3 class="text-lg font-medium font-poppins text-gray-900 dark:text-gray-100 mb-4">
        Business Information
      </h3>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <UiControl id="basics-name" label="Business Name">
          <UiInput v-model="form.name" placeholder="e.g. Acme Plumbing" />
        </UiControl>
        <UiControl id="basics-website" label="Website URL">
          <UiInput v-model="form.website_url" placeholder="https://example.com" />
        </UiControl>
        <UiControl id="basics-industry" label="Industry">
          <UiSelect id="basics-industry-select" v-model="form.industry" :options="industryOptions" />
        </UiControl>
        <UiControl id="basics-primary-service" label="Primary Service Offering">
          <UiInput v-model="form.primary_service_offering" placeholder="e.g. residential roofing" />
        </UiControl>
      </div>
    </div>

    <div class="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-6">
      <h3 class="text-lg font-medium font-poppins text-gray-900 dark:text-gray-100 mb-4">
        Primary Contact
      </h3>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <UiControl id="basics-contact-name" label="Contact Name">
          <UiInput v-model="form.contact_name" placeholder="Full name" />
        </UiControl>
        <UiControl id="basics-contact-email" label="Contact Email">
          <UiInput v-model="form.contact_email" type="email" placeholder="email@example.com" />
        </UiControl>
        <UiControl id="basics-contact-phone" label="Contact Phone">
          <UiInput v-model="form.contact_phone" placeholder="(555) 123-4567" />
        </UiControl>
      </div>
    </div>

    <div class="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-6">
      <h3 class="text-lg font-medium font-poppins text-gray-900 dark:text-gray-100 mb-4">
        Billing Contact
      </h3>
      <p class="text-sm text-gray-500 dark:text-gray-400 mb-4">Only fill in if different from the primary contact.</p>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <UiControl id="basics-billing-name" label="Billing Contact Name">
          <UiInput v-model="form.billing_contact_name" placeholder="Full name" />
        </UiControl>
        <UiControl id="basics-billing-email" label="Billing Contact Email">
          <UiInput v-model="form.billing_contact_email" type="email" placeholder="email@example.com" />
        </UiControl>
        <UiControl id="basics-billing-phone" label="Billing Contact Phone">
          <UiInput v-model="form.billing_contact_phone" placeholder="(555) 123-4567" />
        </UiControl>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import UiControl from '~/javascript/components/ui/form/control/control.vue'
import UiInput from '~/javascript/components/ui/form/input/input.vue'
import UiSelect from '~/javascript/components/ui/form/select/select.vue'

const props = defineProps({
  stepKey: { type: String, required: true },
  label: { type: String, required: true },
  onboarding: { type: Object, required: true },
  mode: { type: String, required: true }
})

const industryOptions = [
  { id: 'home_services', title: 'Home Services' },
  { id: 'legal', title: 'Legal' },
  { id: 'medical', title: 'Medical' },
  { id: 'dental', title: 'Dental' },
  { id: 'real_estate', title: 'Real Estate' },
  { id: 'ecommerce', title: 'E-commerce' },
  { id: 'saas', title: 'SaaS' },
  { id: 'local_service', title: 'Local Service' },
  { id: 'other', title: 'Other' }
]

const form = ref({
  name: '',
  website_url: '',
  industry: '',
  primary_service_offering: '',
  contact_name: '',
  contact_email: '',
  contact_phone: '',
  billing_contact_name: '',
  billing_contact_email: '',
  billing_contact_phone: ''
})

onMounted(() => {
  const o = props.onboarding
  form.value.name = o.business_name || ''
  form.value.website_url = o.business_website_url || ''
  form.value.industry = o.industry || ''
  form.value.primary_service_offering = o.primary_service_offering || ''
  form.value.contact_name = o.contact_name || ''
  form.value.contact_email = o.contact_email || ''
  form.value.contact_phone = o.contact_phone || ''
  form.value.billing_contact_name = o.billing_contact_name || ''
  form.value.billing_contact_email = o.billing_contact_email || ''
  form.value.billing_contact_phone = o.billing_contact_phone || ''
})

defineExpose({
  getData: () => ({ ...form.value })
})
</script>
